module.exports = __webpack_public_path__ + "static/media/sub-banner-01-1.37a2b859.png";